const StarActiveIcon = ({ ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.70534 1.58302C6.82583 1.33886 7.17399 1.33886 7.29448 1.58302L8.85432 4.74359C8.90217 4.84054 8.99466 4.90774 9.10165 4.92329L12.5896 5.43011C12.859 5.46926 12.9666 5.80037 12.7716 5.99042L10.2477 8.45058C10.1703 8.52605 10.135 8.63478 10.1533 8.74134L10.7491 12.2151C10.7951 12.4835 10.5134 12.6881 10.2724 12.5614L7.15277 10.9213C7.05707 10.871 6.94275 10.871 6.84705 10.9213L3.72738 12.5614C3.48638 12.6881 3.20472 12.4835 3.25075 12.2151L3.84655 8.74134C3.86483 8.63478 3.8295 8.52605 3.75208 8.45058L1.22821 5.99042C1.03325 5.80037 1.14083 5.46926 1.41027 5.43011L4.89817 4.92329C5.00516 4.90774 5.09765 4.84054 5.1455 4.74359L6.70534 1.58302Z"
        fill="#E6E6E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.31302 1.38939C6.59399 0.820072 7.40583 0.820072 7.6868 1.38939L9.22128 4.49858L12.6525 4.99716C13.2807 5.08845 13.5316 5.86055 13.077 6.30371L10.5942 8.72387L11.1803 12.1412C11.2876 12.7669 10.6308 13.2441 10.0689 12.9487L6.99991 11.3352L3.93096 12.9487C3.36901 13.2441 2.71222 12.7669 2.81955 12.1412L3.40566 8.72387L0.922832 6.30371C0.468202 5.86055 0.719073 5.08845 1.34736 4.99716L4.77854 4.49858L6.31302 1.38939ZM6.99991 1.9747L5.53782 4.93721C5.42625 5.16329 5.21057 5.31999 4.96108 5.35624L1.69175 5.8313L4.05746 8.13729C4.23799 8.31327 4.32038 8.56681 4.27776 8.8153L3.71929 12.0714L6.64346 10.5341C6.86661 10.4168 7.13321 10.4168 7.35636 10.5341L10.2805 12.0714L9.72206 8.8153C9.67944 8.56681 9.76183 8.31327 9.94236 8.13729L12.3081 5.8313L9.03874 5.35624C8.78925 5.31999 8.57357 5.16329 8.462 4.93721L6.99991 1.9747Z"
        fill="#E6E6E9"
      />
    </svg>
  );
};

export default StarActiveIcon;
